const device = () => (window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop');

const publish = (name, detail = {}) => {
  const payload = { device: device(), ...detail };
  window.dataLayer?.push({ event: name, ...payload });
  document.dispatchEvent(new CustomEvent(`cdw:analytics:${name}`, { detail: payload }));
};

const productContext = () => {
  const root = document.querySelector('[data-cdw-product-presentation], product-information, .product-information');
  const sku = document.querySelector('[data-cdw-card-sku]')?.textContent?.trim() || '';
  return {
    sku,
    line: document.querySelector('.cdw-product-presentation__eyebrow')?.textContent?.trim() || '',
    finish: document.querySelector('[data-cdw-card-finish]')?.textContent?.trim() || '',
    dimensions: document.querySelector('.cdw-product-presentation__dimensions')?.textContent?.trim() || '',
    has_product_context: Boolean(root),
  };
};

document.addEventListener('DOMContentLoaded', () => {
  const main = document.getElementById('MainContent');
  const template = main?.dataset.template || '';
  if (template.startsWith('collection')) {
    const count = Number(document.querySelector('facets-form-component')?.dataset.resultsCount || 0);
    publish('catalog_view', { collection: document.title, result_count: count });
  }
  if (template.startsWith('product')) publish('product_view', productContext());

  const contactForm = document.querySelector('[data-cdw-contact-form] form');
  if (contactForm?.querySelector('.cdw-contact__success')) {
    const skus = String(new FormData(contactForm).get('contact[SKUs]') || '').split(',').filter(Boolean);
    publish('quote_submit_success', { source_page: document.referrer || window.location.pathname, sku_count: skus.length });
  }
});

document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
  if (target.closest('facet-inputs-component, sorting-filter-component')) {
    publish('filter_applied', {
      facet: target.name,
      value: target.value,
      result_count: Number(target.closest('facets-form-component')?.dataset.resultsCount || 0),
    });
  }
});

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const save = target?.closest('[data-cdw-project-save]');
  if (save instanceof HTMLElement) publish('project_item_saved', { sku: save.dataset.productSku || '', source_template: document.getElementById('MainContent')?.dataset.template || '' });

  const support = target?.closest('a[href^="mailto:"], a[href^="tel:"], a[href*="/pages/contact"]');
  if (support instanceof HTMLAnchorElement) {
    const method = support.href.startsWith('mailto:') ? 'email' : support.href.startsWith('tel:') ? 'phone' : 'form';
    publish('support_click', { method, source_page: window.location.pathname });
  }
});

document.addEventListener('focusin', (event) => {
  const form = event.target instanceof Element ? event.target.closest('[data-cdw-contact-form] form') : null;
  if (!(form instanceof HTMLFormElement) || form.dataset.cdwQuoteStarted === 'true') return;
  form.dataset.cdwQuoteStarted = 'true';
  const skus = String(new FormData(form).get('contact[SKUs]') || '').split(',').filter(Boolean);
  publish('quote_start', { source_page: document.referrer || window.location.pathname, sku_count: skus.length });
});

document.addEventListener(
  'invalid',
  (event) => {
    const field = event.target;
    if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) return;
    if (!field.closest('[data-cdw-contact-form] form')) return;
    publish('quote_error', {
      field: field.name || field.id,
      error_type: field.validity.valueMissing ? 'required' : field.validity.typeMismatch ? 'format' : 'invalid',
    });
  },
  true
);
